import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

interface PrivacyNoticeProps {
  className?: string;
}

/**
 * Krótka klauzula informacyjna RODO przy formularzach.
 * Umieszczana pod przyciskiem "Wyślij" w każdym formularzu.
 */
export const PrivacyNotice = ({ className }: PrivacyNoticeProps) => (
  <p className={cn("text-[10px] sm:text-[11px] text-muted-foreground leading-relaxed text-center break-words", className)}>
    Dane z formularza wykorzystujemy wyłącznie do aktualizacji i weryfikacji profilu schroniska. Szczegóły w{" "}
    <Link
      to="/polityka-prywatnosci"
      className="underline hover:text-foreground"
      target="_blank"
      rel="noopener noreferrer"
    >
      polityce prywatności
    </Link>
    .
  </p>
);
